import { TVChartContainer } from "./chart";

const resource = {
  list: TVChartContainer,
};

export default resource;
